<app-main-layout-wrapper>
  <app-content-box>
    <app-content-logo></app-content-logo>
    <ng-content></ng-content>
  </app-content-box>
</app-main-layout-wrapper>
